import { useState, useEffect } from "react";
import styles from "./qwerty.module.scss"; 

export default function Qwerty({ guess, word, onKeyPress, isGuessed, handleResetQwerty, setHandleResetQwerty }) {
    const qwerty = ["qwertyuiop", "asdfghjkl", "zxcvbnm"];

    const [exactGuesses, setExactGuesses] = useState([]);
    const [inexactGuesses, setInexactGuesses] = useState([]);
    const [allGuesses, setAllGuesses] = useState([]);

    useEffect(() => {
        if (!isGuessed) return;
        console.log("Test")
    
        const exact = new Set(exactGuesses);
        const inexact = new Set(inexactGuesses);
        const all = new Set(allGuesses);
    
        let isFinalGuessCorrect = guess === word; // Detect if the guess is correct
    
        guess.split("").forEach((letter, index) => {
            all.add(letter); // Keep track of all guessed letters
    
            if (word[index] === letter) {
                exact.add(letter); // Correct position (Green)
                inexact.delete(letter); // Remove from inexact if it was previously yellow
            } else if (word.includes(letter) && !exactGuesses.includes(letter)) {
                inexact.add(letter); // Incorrect position (Yellow)
            }
        });
    
        // If the final guess is correct, ensure all letters turn green
        if (isFinalGuessCorrect) {
            word.split("").forEach((letter) => {
                exact.add(letter);
                inexact.delete(letter);
            });
        }
    
        setExactGuesses([...exact]);
        setInexactGuesses([...inexact]);
        setAllGuesses([...all]);
    
    }, [guess, word, isGuessed]);
    
    

    useEffect(() => {
        if (handleResetQwerty) {
            setExactGuesses([]);
            setInexactGuesses([]);
            setAllGuesses([]);
        }

        setTimeout(() => {
            setHandleResetQwerty(false);
        }, 0)

    }, [handleResetQwerty, setHandleResetQwerty])

    function getKeyClass(char) {
        if (exactGuesses.includes(char)) {
            return styles.exact;
        } else if (!exactGuesses.includes(char) && inexactGuesses.includes(char)) {
            return styles.inexact;
        } else if (!exactGuesses.includes(char) && !inexactGuesses.includes(char) && allGuesses.includes(char)) {
            return styles.guessed;
        } else {
            return styles.default;
        }
    }

    return (
        <div className={styles["qwerty-container"]}>
            {qwerty.map((row, rowIndex) => (
                <div key={rowIndex} className={styles["qwerty-row"]}>
                    {row.split("").map((char, charIndex) => (
                        <button 
                            key={charIndex} 
                            className={`${styles["qwerty-key"]} ${getKeyClass(char)}`} 
                            onClick={() => onKeyPress({ key: char })}
                        >
                            {char}
                        </button>
                    ))}
                </div>
            ))}
            <button className={styles["qwerty-key-enter"]} onClick={() => onKeyPress({ key: "Enter" })}>Enter</button>
            <div className={styles["qwerty-key-delete"]}>
                <i className={`${styles["qwerty-key-deleteicon"]} fa-solid fa-delete-left`} 
                onClick={() => onKeyPress({ key: "Backspace" })}>
                </i>
            </div>
        </div>
    );
}
